// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ef9084cb","644":"1699eea3","732":"6fd50fb0"}[chunkId] + ".chunk.js";
};